import React, { useEffect, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import Card from 'saur_ui_library/src/Molecules/Card/Card';import { defineDefinitionExpression } from '../../../utils/helpers/map/defExpHelper';
import { getInfoBulleMessage, getOptionsCommunes, getOptionsInstalls, resetImputLabel, resetOptions } from '../../../utils/helpers/module/filtersHelper';
import { colorFormated } from '../../../utils/helpers/module/moduleComponentHelper';
import DataSelector from '../../common/component/dataSelector';
import Legend from '../../common/component/Legend';
import DoubleFilter from '../component/DoubleFilter';
import SingleFilter from '../component/SingleFilter';
import { criticityOptionsPrMr } from '../options/optionsHelper';
import { loaderDataComponent } from '../../../utils/helper';

const FiltersPrMr = (props: any) => {
  const contractCode = window.sessionStorage.getItem('contractCode') || '';
  // const for dropdownlist on change
  const [fonctionnement, setFonctionnement] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('pr_color')!) || ''
  );
  const [commune, setCommune] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('pr_commune')!) || {
      name: '',
      code: '',
    }
  );
  const [criticity, setCriticity] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('pr_criticity')!) || {
      name: '',
      code: '',
    }
  );
  const [installations, setInstallations] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('pr_installation')!) || {
      name: '',
      code: '',
    }
  );
  // const for dropdownlists options
  const [communeOptions, setCommuneOptions] = useState<any>([]);
  const [installsOptions, setInstallsOptions] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const infoBulleMessageDataSelectorPrMr = getInfoBulleMessage(props.module);

  // get communes options
  const getCommune = async () => {
    const optionsCommune = await getOptionsCommunes(
      contractCode,
      '51',
      props.module
    );
    if (optionsCommune.length === 0) {
      resetImputLabel('pr-filtre-commune');
    }
    setCommuneOptions(optionsCommune);
  };

  // get installs options
  const getInstall = async (pFilters: any) => {
    const res = await getOptionsInstalls(
      defineDefinitionExpression(
        pFilters,
        'modules',
        contractCode
      ),
      '102'
    );
    if (res.length === 0) {
      resetImputLabel('pr-filtre-installation');
    }
    setInstallsOptions(res);
  };

  // component did mount
  useEffect(() => {
    // load memory and launch table and map
    props.parentCallback({
      Color: fonctionnement,
      InseeCode: commune,
      CriticityCode: criticity,
      Code: installations,
    });
    setLoading(true);
    getCommune().then(() => {
      setLoading(false);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // trigger dynamic dropdownlists hence on change (commune, type and deversement)
  useEffect(() => {
    if(loading === false){
      setLoading(true);
      getInstall({
        Color: colorFormated(fonctionnement),
        InseeCode: commune,
        CriticityCode: criticity,
      }).then(() => {
        setLoading(false);
      });
    }
  }, [commune, criticity, fonctionnement]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container className='filterForm'>
      <Card automatedTestId={props.module + '-filter'}>
        <Word
          value='FILTRER MA RECHERCHE'
          textStyle='title'
          variant='h1'
          automatedTestId='search-word'
        />
        <Legend type={localStorage.getItem('type')!} />
        <Container className='fonctionnement'>
          <Word
            value='Fonctionnement'
            textStyle='normalReg'
            variant='p'
            automatedTestId='id-fonctionnement'
          />
          <DataSelector
            infoBulles={infoBulleMessageDataSelectorPrMr}
            sendSelectedColor={(d: any) => {
              setFonctionnement(d);
              fonctionnement !== '' &&
                props.parentCallback({
                  Color: d,
                  InseeCode: commune,
                  CriticityCode: criticity,
                  Code: installations,
                });
              window.sessionStorage.setItem('pr_color', JSON.stringify(d));
            }}
            type='standard'
            sessionStorageName='pr_color'
          />
        </Container>
        {commune !== null && (
          <DoubleFilter
            module='pr'
            titleOne='Communes :'
            filterNameOne='commune'
            filterOneOptions={communeOptions}
            titleTwo='Criticité :'
            filterNameTwo='criticity'
            filterTwoOptions={criticityOptionsPrMr}
            parentCallbackOne={(d) => {
              setCommune(d);
              resetOptions(
                d,
                'pr-filtre-installation',
                setInstallsOptions
              );
              props.parentCallback({
                Color: fonctionnement,
                InseeCode: d,
                CriticityCode: criticity,
                Code: {
                  name: '',
                  code: '',
                },
              });
            }}
            parentCallbackTwo={(d) => {
              setCriticity(d);
              props.parentCallback({
                Color: fonctionnement,
                InseeCode: commune,
                CriticityCode: d,
                Code: {
                  name: '',
                  code: '',
                },
              });
            }}
          />
        )}
        {installations !== null && (
          <SingleFilter
            module='pr'
            title='Installations :'
            filterName='installation'
            filterOptions={installsOptions}
            parentCallback={(d) => {
              setInstallations(d);
              props.parentCallback({
                Color: fonctionnement,
                InseeCode: commune,
                CriticityCode: criticity,
                Code: d,
              });
            }}
          />
        )}
        {loaderDataComponent(loading)}
      </Card>
    </Container>
  );
};
export default FiltersPrMr;
